import React, { useState } from "react";
import { AiOutlineClose } from "react-icons/ai";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { formatDate, getArticleName } from "common/FunctionUtils";
import Loader from "components/Loader";
import PdfView from "./PdfView";
import { HourlyWages } from "common/StringUtils";
import { ARTICLE_NUMBERS } from "common/constants";
import axios from "axios";

export const ViewInvoiceModal = ({
  showDetails,
  setShowDetails,
  getPdfData,
}) => {
  const { t } = useTranslation();

  const [isLoading, setisLoading] = useState(false);

  const { invoiceDetails } = showDetails;
  const amount = invoiceDetails?.amount || 0;
  const customerVat = invoiceDetails?.invoiceCustomerVat || 0;
  const total = (amount * customerVat) / 100 + amount;
  const formattedTotal = Number.isInteger(amount) ? total - invoiceDetails?.rutDeductionAmount - invoiceDetails?.rootDeductionAmount : Number(total)?.toFixed(2);

  const { user } = useSelector((state) => state?.auth);

  let mergeArticleNo92;
  let otherArticleValues;

  if (invoiceDetails?.workingHours) {
    const mergeTotalAmount =
      // cloneInvoiceHours[0] &&
      invoiceDetails?.workingHours
        .filter((item) => {
          return (
            item?.articleNumber !== ARTICLE_NUMBERS.MILEAGE_TAX_FREE &&
            item?.articleNumber !== ARTICLE_NUMBERS.MILEAGE_WITH_TAX &&
            item?.articleNumber !== ARTICLE_NUMBERS.ALLOWANCE_OUT_TAX_FREE &&
            item?.articleNumber !== ARTICLE_NUMBERS.ALLOWANCE_OUT_WITH_TAX &&
            item?.articleNumber !== ARTICLE_NUMBERS.ALLOWANCE_IN_TAX_FREE_HALF_DAY &&
            item?.articleNumber !== ARTICLE_NUMBERS.ALLOWANCE_IN_TAX_FREE_FULL_DAY &&
            item?.articleNumber !== ARTICLE_NUMBERS.ALLOWANCE_IN_WITH_TAX_HALF_DAY &&
            item?.articleNumber !== ARTICLE_NUMBERS.ALLOWANCE_IN_WITH_TAX_FULL_DAY &&
            item?.articleNumber !== ARTICLE_NUMBERS.TRAVEL &&
            item?.articleNumber !== ARTICLE_NUMBERS.MATERIAL_VAT_TAX_FREE &&
            item?.articleNumber !== ARTICLE_NUMBERS.MATERIAL_VAT_WITH_TAX
          );
        })
        .map((item, index) => {
          return {
            ...item,
            totalAmount:
              parseFloat(item.amountPerUnit) * parseFloat(item.number),
            calculatedAmounts:
              parseFloat(item.amountPerUnit) * parseFloat(item.number),
            otherArticleSum: 0,
          };
        });

    const otherArticleSum = mergeTotalAmount?.reduce((acc, curr) => {
      if (curr.article?.articleNumber !== HourlyWages) {
        acc += parseFloat(curr.amount);
      }
      return acc;
    }, 0);

    mergeArticleNo92 = mergeTotalAmount?.reduce((result, item) => {
      if (item?.articleNumber === HourlyWages) {
        const existingItem = result.find(
          (i) => i.articleNumber === HourlyWages
        );
        if (existingItem) {
          existingItem.number =
            parseFloat(existingItem.number) + parseFloat(item.number);
          existingItem.amount =
            parseFloat(existingItem.amountPerUnit) +
            parseFloat(item.amountPerUnit);
          existingItem.totalAmount += item.amountPerUnit * item.number;
          existingItem.calculatedAmounts = invoiceDetails?.amountPerUnit;
          existingItem.otherArticleSum = otherArticleSum;
        } else {
          result.push({ ...item });
        }
      } else {
        result.push({ ...item });
      }
      return result;
    }, []);

    otherArticleValues = invoiceDetails?.workingHours.filter(
      (item) =>
      item?.articleNumber === ARTICLE_NUMBERS.MILEAGE_TAX_FREE ||
      item?.articleNumber === ARTICLE_NUMBERS.MILEAGE_WITH_TAX ||
      item?.articleNumber === ARTICLE_NUMBERS.ALLOWANCE_OUT_TAX_FREE ||
      item?.articleNumber === ARTICLE_NUMBERS.ALLOWANCE_OUT_WITH_TAX ||
      item?.articleNumber === ARTICLE_NUMBERS.ALLOWANCE_IN_TAX_FREE_HALF_DAY ||
      item?.articleNumber === ARTICLE_NUMBERS.ALLOWANCE_IN_TAX_FREE_FULL_DAY ||
      item?.articleNumber === ARTICLE_NUMBERS.ALLOWANCE_IN_WITH_TAX_HALF_DAY ||
      item?.articleNumber === ARTICLE_NUMBERS.ALLOWANCE_IN_WITH_TAX_FULL_DAY ||
      item?.articleNumber === ARTICLE_NUMBERS.TRAVEL ||
      item?.articleNumber === ARTICLE_NUMBERS.MATERIAL_VAT_TAX_FREE ||
      item?.articleNumber === ARTICLE_NUMBERS.MATERIAL_VAT_WITH_TAX
    );
  }
  let forpAmount;
  if (showDetails) {
    forpAmount = showDetails?.invoiceDetails?.workingHours
      .filter(
        (item) => item?.articleNumber === "2" || item?.articleNumber === "1"
      )
      .reduce((acc, item) => (acc += item?.amountPerUnit), 0);
  }

  const language = localStorage.getItem("i18nextLng");

  return (
    <div>
      {isLoading && <Loader />}
      <Modal
        show={showDetails.invoiceDetails}
        onHide={() =>
          setShowDetails((prevState) => ({
            ...prevState,
            invoiceDetails: null,
          }))
        }
        size="xl"
        scrollable
        className="invoice-dialog"
      >
        <Modal.Header>
          <AiOutlineClose
            className="ml-auto cursor-pointer"
            size={24}
            onClick={() =>
              setShowDetails((prevState) => ({
                ...prevState,
                invoiceDetails: null,
              }))
            }
          />
        </Modal.Header>
        <Modal.Body className="p-3">
          <div id="invoice-dialog-div">
            <div className="logo-info ">
              <div>
                <div className="heading d-flex align-items-center justify-content-between px-3">
                  <div className="logo-pdf">
                    <img
                      src="/assets/fakt-logo.png"
                      alt="logo"
                      className="logo"
                    />
                  </div>
                  <div className="date-text">
                    <h4 className="mb-0">
                      <span>
                        {formatDate(
                          invoiceDetails.createdDate,
                          false,
                          language
                        )}
                      </span>
                    </h4>
                  </div>
                </div>
              </div>
              <div>
                <div className="px-3 py-2 mb-3 flex-change">
                  <h3 className="text-right">
                    {invoiceDetails?.customerAddress?.name || invoiceDetails?.customer?.name}
                  </h3>
                  <p className="text-right m-0">
                    {invoiceDetails?.customerAddress?.address || invoiceDetails?.customer?.address},{" "}
                    {invoiceDetails?.customerAddress?.zipCode || invoiceDetails?.customer?.zipCode},{" "}
                    {invoiceDetails?.customerAddress?.city || invoiceDetails?.customer?.city},{" "}
                    {invoiceDetails?.customerAddress?.country || invoiceDetails?.customer?.country}
                  </p>

                  <p className="text-right m-0">
                    {t("Tel: ")}
                    {invoiceDetails?.customerAddress?.phoneNumber || invoiceDetails?.customer?.phoneNumber}
                  </p>
                </div>
              </div>
            </div>
            <div className="row mb-3">
              <div className="col">
                <div className="customer d-flex align-items-center justify-content-between">
                  <div className="first">
                    <div className="inner-group">
                      <div className="customer-data d-flex align-items-center">
                        <h4 className="m-0">{t("Customer no")}:</h4>
                        <p className="m-0">
                          {invoiceDetails?.customerAddress?.customerId || invoiceDetails?.customer?.customerId}
                        </p>
                      </div>
                      <div className="customer-data d-flex align-items-center">
                        <h4 className="m-0">{t("Invoice number")}:</h4>
                        <p className="m-0">{invoiceDetails?.invoiceNumber}</p>
                      </div>
                      <div className="customer-data d-flex align-items-center">
                        <h4 className="m-0">{t("Your reference")}:</h4>
                        <p className="m-0">
                          {" "}
                          {invoiceDetails?.customerAddress?.reference || invoiceDetails?.customer?.reference}
                        </p>
                      </div>
                      <div className="customer-data d-flex align-items-center">
                        <h4 className="m-0">{t("Your VAT number")}:</h4>
                        <p className="m-0">
                          {invoiceDetails?.customerAddress?.vatNumber || invoiceDetails?.customer?.vatNumber}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="second">
                    <div className="inner-group">
                      <div className="customer-data d-flex align-items-center">
                        <h4 className="m-0">{t("Our reference")}:</h4>
                        <p className="m-0">
                          {user?.firstName} {user?.lastName}
                        </p>
                      </div>
                      <div className="customer-data d-flex align-items-center">
                        <h4 className="m-0">{t("Payment terms")}:</h4>
                        <p className="m-0">
                          {invoiceDetails?.customerAddress?.paymentTerm || invoiceDetails?.customer?.paymentTerm } days
                        </p>
                      </div>
                      <div className="customer-data d-flex align-items-center">
                        <h4 className="m-0">{t("Due Date")}:</h4>
                        <p className="m-0">
                          {" "}
                          {formatDate(invoiceDetails?.dueDate, false, language)}
                          {/* {formatDate(
                            invoiceDetails?.createdDate,
                            invoiceDetails?.customerAddress?.paymentTerm
                          )} */}{" "}
                        </p>
                      </div>
                      <div className="customer-data d-flex align-items-center">
                        <h4 className="m-0">{t("Invoice date")}:</h4>
                        <p className="m-0">
                          {" "}
                          {formatDate(
                            invoiceDetails?.createdDate,
                            false,
                            language
                          )}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row mb-3">
              <div className="col overflow-auto show-invoice-wrapper">
                <table className="show-invoice-table w-100">
                  <tbody>
                    <tr className="border-invoice">
                      <th>{t("Article No:")}</th>
                      <th>{t("Na")}</th>
                      <th>{t("Quantity")}</th>
                      <th>{t("Unit")}</th>
                      <th>{t("Price per unit")}</th>
                      <th>{t("Tot")}</th>
                    </tr>
                    {invoiceDetails.showDates !== true &&
                    !invoiceDetails.multipleFreelancer
                      ? mergeArticleNo92?.map((invoiceItem, index) => {
                          return (
                            <tr key={index}>
                              <td className="m-0">
                                {invoiceItem?.articleNumber}
                              </td>
                              <td className="m-0">
                                {t(getArticleName(invoiceItem?.articleNumber))}{" "}
                                {invoiceDetails.showDates === true &&
                                  invoiceItem?.workingDate?.split("T")[0]}
                              </td>
                              <td className="m-0">
                                <span style={{ cursor: "default" }}>
                                  {invoiceItem?.articleNumber === HourlyWages
                                    ? invoiceItem?.number
                                    : 1}
                                </span>
                              </td>
                              <td
                                className="m-0 cursor-pointer"
                                title={t(invoiceItem?.workingDescription)}
                              >
                                {invoiceItem?.unit}
                              </td>
                              <td className="m-0">
                                {invoiceDetails.isFixed
                                  ? Number.isInteger(
                                      (invoiceItem?.calculatedAmounts -
                                        invoiceItem?.otherArticleSum) /
                                        invoiceItem.number
                                    )
                                    ? (invoiceItem?.calculatedAmounts -
                                        invoiceItem?.otherArticleSum) /
                                      invoiceItem.number
                                    : parseFloat(
                                        (invoiceItem?.calculatedAmounts -
                                          invoiceItem?.otherArticleSum) /
                                          invoiceItem.number
                                      )?.toFixed(2)
                                  : Number.isInteger(
                                      invoiceItem.totalAmount /
                                        invoiceItem.number
                                    )
                                  ? invoiceItem.totalAmount / invoiceItem.number
                                  : parseFloat(
                                      invoiceItem.totalAmount /
                                        invoiceItem.number
                                    )?.toFixed(2)}
                              </td>
                              <td className="m-0">
                                {invoiceDetails?.isFixed
                                  ? t("Fixed Price")
                                  : ""}{" "}
                                {!invoiceDetails?.isFixed &&
                                  invoiceItem?.articleNumber &&
                                  invoiceItem?.number &&
                                  Number(invoiceItem?.totalAmount)?.toFixed(2)}
                              </td>
                            </tr>
                          );
                        })
                      : invoiceDetails?.workingHours
                          ?.filter(
                            (item) =>
                            item?.articleNumber !== ARTICLE_NUMBERS.MILEAGE_TAX_FREE &&
                            item?.articleNumber !== ARTICLE_NUMBERS.MILEAGE_WITH_TAX &&
                            item?.articleNumber !== ARTICLE_NUMBERS.ALLOWANCE_OUT_TAX_FREE &&
                            item?.articleNumber !== ARTICLE_NUMBERS.ALLOWANCE_OUT_WITH_TAX &&
                            item?.articleNumber !== ARTICLE_NUMBERS.ALLOWANCE_IN_TAX_FREE_HALF_DAY &&
                            item?.articleNumber !== ARTICLE_NUMBERS.ALLOWANCE_IN_TAX_FREE_FULL_DAY &&
                            item?.articleNumber !== ARTICLE_NUMBERS.ALLOWANCE_IN_WITH_TAX_HALF_DAY &&
                            item?.articleNumber !== ARTICLE_NUMBERS.ALLOWANCE_IN_WITH_TAX_FULL_DAY &&
                            item?.articleNumber !== ARTICLE_NUMBERS.TRAVEL &&
                            item?.articleNumber !== ARTICLE_NUMBERS.MATERIAL_VAT_TAX_FREE &&
                            item?.articleNumber !== ARTICLE_NUMBERS.MATERIAL_VAT_WITH_TAX
                          )
                          .map((allIndex) => (
                            <tr key={allIndex.id}>
                              <td className="m-0">
                                {" "}
                                {allIndex?.articleNumber}{" "}
                              </td>
                              <td className="m-0">
                                {t(getArticleName(allIndex?.articleNumber))}{" "}
                                {invoiceDetails?.showDates === true &&
                                  allIndex?.workingDate?.split("T")[0]}{" "}
                                ({allIndex?.freelancerName})
                              </td>
                              <td className="m-0">
                                <span style={{ cursor: "default" }}>
                                  {allIndex.articleNumber === HourlyWages
                                    ? allIndex?.number
                                    : 1}
                                </span>
                              </td>
                              <td className="m-0"> {t(allIndex.unit)}</td>
                              <td className="m-0">
                                {" "}
                                {allIndex.amountPerUnit !== ""
                                  ? allIndex?.amountPerUnit
                                  : 0}
                              </td>
                              <td className="m-0">
                                {invoiceDetails?.isFixed
                                  ? t("Fixed Price")
                                  : ""}{" "}
                                {!invoiceDetails?.isFixed &&
                                  allIndex.articleNumber &&
                                  allIndex.unit &&
                                  allIndex.amountPerUnit !== "" &&
                                  Number(parseFloat(allIndex.amountPerUnit)) *
                                    parseFloat(allIndex.number)}
                                {!invoiceDetails?.isFixed &&
                                  allIndex?.articleNumber &&
                                  allIndex?.unit &&
                                  allIndex.amountPerUnit === "" &&
                                  0 * parseFloat(allIndex.number)}
                              </td>
                            </tr>
                          ))}

                    {otherArticleValues?.length > 0 &&
                      otherArticleValues
                      ?.filter((item) => item?.isArticleShownInInvoice === true)
                      ?.map((item) => (
                        <tr key={item.id}>
                          <td className="m-0">
                            {item?.articleNumber}
                          </td>
                          <td className="m-0">
                            {t(getArticleName(item?.articleNumber))} (
                            {item?.freelancerName})
                          </td>
                          <td className="m-0">
                            <span style={{ cursor: "default" }}>
                              {item?.number}
                            </span>
                          </td>
                          <td className="m-0 cursor-pointer">{t(item?.unit)}</td>
                          <td className="m-0">{item?.amountPerUnit}</td>

                          <td className="m-0">
                            {invoiceDetails?.isFixed
                              ? t("Fixed Price")
                              : item?.amountPerUnit * item?.number}
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </div>

            <div className="row">
              <div className="col">
                <div
                  className=" p-0 description"
                  style={{ wordWrap: "break-word" }}
                >
                  <p className="m-0">{invoiceDetails?.description}</p>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col">
                {invoiceDetails?.rotDeduction && (
                  <>
                    {!invoiceDetails?.house && (
                      <>
                        {invoiceDetails?.brfNo && (
                          <p>
                            <span className="font-weight-bold">
                              {t("Brf org. number")} :
                            </span>{" "}
                            {invoiceDetails?.brfNo}{" "}
                          </p>
                        )}
                      </>
                    )}

                    {invoiceDetails?.rotApartmentNo && (
                      <p>
                        {
                          <>
                            {invoiceDetails?.house ? (
                              <span className="font-weight-bold">
                                {t("Property")}
                              </span>
                            ) : (
                              <span className="font-weight-bold">
                                {t("Apartment number")}
                              </span>
                            )}
                          </>
                        }
                        : {invoiceDetails?.rotApartmentNo}
                      </p>
                    )}
                  </>
                )}
                {(invoiceDetails?.customerAddress?.ssn || invoiceDetails?.customer?.ssn) && (
                  <p>
                    {" "}
                    <span className="font-weight-bold">
                      {t("SSN No.") + ":"}
                    </span>{" "}
                    {invoiceDetails?.customerAddress?.ssn || invoiceDetails?.customer?.ssn}
                  </p>
                )}
              </div>
            </div>

            <div className="row">
              <div className="col">
                <div className="border border-light vat rounded p-2 mb-3">
                  <div className="d-flex mb-3 response-data justify-content-between">
                    <div className="text-center">
                      <h6 className="m-0">{t("Excluding VAT")}</h6>
                      <h6 className="m-0">
                        {Number.isInteger(invoiceDetails?.amount)
                          ? invoiceDetails?.amount
                          : parseFloat(invoiceDetails?.amount)?.toFixed(2)}
                      </h6>
                    </div>
                    <div className="text-center">
                      <h6 className="m-0">{t("VAT")} %</h6>
                      <h6 className="m-0">{invoiceDetails?.invoiceCustomerVat}</h6>
                    </div>
                    <div className="text-center">
                      <h6 className="m-0">{t("VAT")}</h6>

                      <h6 className="m-0">
                        {((invoiceDetails?.amount - forpAmount) *
                          invoiceDetails?.invoiceCustomerVat) /
                          100}
                      </h6>
                    </div>
                    <div className="text-center">
                      <h6 className="m-0">{t("Round-off")}</h6>
                      <h6 className="m-0">0</h6>
                    </div>
                    <div className="text-center">
                      <h6 className="m-0">{t("Currency")}</h6>
                      <h6 className="m-0">{invoiceDetails?.currency}</h6>
                    </div>

                    {invoiceDetails?.rootDeductionAmount == 0 &&
                    invoiceDetails?.rutDeductionAmount == 0 ? null : (
                      <div className="text-center">
                        {invoiceDetails?.rootDeductionAmount == 0 && (
                          <h6 className="m-0">{t("RUT")}</h6>
                        )}
                        {invoiceDetails?.rutDeductionAmount == 0 && (
                          <h6 className="m-0">{t("ROT")}</h6>
                        )}

                        {invoiceDetails?.rootDeductionAmount == 0 && (
                          <h6 className="m-0">
                            {invoiceDetails?.rutDeductionAmount}
                          </h6>
                        )}

                        {invoiceDetails?.rutDeductionAmount == 0 && (
                          <h6 className="m-0">
                            {invoiceDetails?.rootDeductionAmount}
                          </h6>
                        )}
                      </div>
                    )}

                    <div className="text-center">
                      <h6 className="m-0 font-weight-bold">{t("To pay")}</h6>
                      <h6 className="m-0 ">
                        <span>
                          {invoiceDetails?.amountIncVat} {invoiceDetails?.currency}
                        </span>
                      </h6>
                    </div>
                  </div>
                </div>

                <div className="page-content EconomyInvoices">
                  <div className="invoice-details-container">
                    <div className="invoice-details-part-container flex-column w-100">
                      {/* <div className="invoice-details-title">
                        {t("INVOICE STATUS")}
                      </div> */}
                      {/* <div className="invoice-activity-status-container">
                        <div className="invoice-activity-status-steps">
                          <div className="invoice-activity-status-step first">
                            <div
                              className={`invoice-activity-status-step-circle ${
                                invoiceDetails?.invoiceApprovalStatus === 1
                                  ? "undenied"
                                  : "denied"
                              }`}
                            >
                              <div className="invoice-activity-status-step-circle-icon">
                                {invoiceDetails?.invoiceApprovalStatus === 1
                                  ? "✕"
                                  : "✔"}
                              </div>
                            </div>
                          </div>
                          <div className="invoice-activity-status-step">
                            <div className="invoice-activity-status-step-line dotted"></div>
                            <div
                              className={`invoice-activity-status-step-circle ${
                                invoiceDetails?.invoiceStatus === 2
                                  ? "denied"
                                  : "undenied"
                              }`}
                            >
                              <div className="invoice-activity-status-step-circle-icon">
                                {invoiceDetails?.invoiceStatus === 2
                                  ? "✔"
                                  : "✕"}
                              </div>
                            </div>
                          </div>
                          <div className="invoice-activity-status-step">
                            <div className="invoice-activity-status-step-line dotted"></div>
                            <div
                              className={`invoice-activity-status-step-circle ${
                                invoiceDetails?.invoiceSalaryStatus === 2
                                  ? "denied"
                                  : "undenied"
                              }`}
                            >
                              <div className="invoice-activity-status-step-circle-icon">
                                {invoiceDetails?.invoiceSalaryStatus === 2
                                  ? "✔"
                                  : "✕"}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div> */}

                      {/* <div className="invoice-activity-status-text-container">
                        <div className="invoice-activity-status-text">
                          <div className="invoice-activity-status-text-title ">
                            {invoiceDetails?.invoiceApprovalStatus === 1 ? (
                              <span>{t("Unapproved")}</span>
                            ) : (
                              <span>{t("Approved")}</span>
                            )}
                          </div>
                        </div>
                        <div className="invoice-activity-status-text">
                          <div className="invoice-activity-status-text-title ">
                            <span>{t("Invoice payment")}</span>
                          </div>
                        </div>
                        <div className="invoice-activity-status-text">
                          <div className="invoice-activity-status-text-title ">
                            <span>{t("Salary payment")}</span>
                          </div>
                        </div>
                      </div> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="bottom-part px-3">
              <h4 className="invoice m-0">{t("Invozio LV SIA")}</h4>
              <div className="contact">
                <p className="m-0">{import.meta.env.VITE_SUPPORT_PHONE_NUMBER}</p>
                <p className="m-0">{t("support@invozio.com")}</p>
              </div>
              <div className="address">
                <p className="m-0">{t("Invozio LV SIA")}</p>
                <p className="m-0">
                  {t("Org. Number")}: <span> 502085-4062</span>
                </p>
                <p className="m-0">
                  {t("Vat Number")}: <span>SE502085406201 </span>
                </p>
              </div>
            </div>

            <PdfView viewPdf={getPdfData?.invoiceFileUpload} />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="outline_btn_new active"
            variant="secondary"
            onClick={() =>
              setShowDetails((prevState) => ({
                ...prevState,
                invoiceDetails: null,
              }))
            }
          >
            {t("Close")}
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export const handleViewPdf = async (invoiceNumber,data, setIsLoading) => {
  try {
    const lang = data?.customer?.country === "Sweden" ? 'sv-se' : 'en-us';
    setIsLoading(true);
    const response = await axios.get(`/invoice/invoice-pdf-client?invoiceNumber=${invoiceNumber}&locale=${lang}`, {
      responseType: 'blob'
    });
    
    if (response.status !== 200) {
      throw new Error('Failed to fetch PDF');
    }
    
    const url = window.URL.createObjectURL(response.data);
    window.open(url, '_blank');
    
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `${invoiceNumber}.pdf`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    console.error('PDF fetch error:', error);
  } finally {
    setIsLoading(false);
  }
};
